import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataService } from 'src/app/facilityOperations/facOps-dashboard/data.service';
import { twoWayService } from 'src/app/services/operations/two-way-text.service';
import { ISendSMSLogsResponse } from '../interface2';
import { CustomerDataService } from 'src/app/facilityOperations/facOps-customer/customer-data.service';
import { promise } from 'protractor';
import { FacOpsDataService } from 'src/app/services/operations/facOpsDataService.service';
import { TooltipComponent } from '@syncfusion/ej2-angular-popups';
import { UserSessionService } from 'src/app/services/usersession.service';
import { CommonMethodService } from '../common-method.service';
import { DatePipe } from '@angular/common';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';


@Component({
    selector: 'app-smslog-popup',
    templateUrl: './smslog-popup.component.html',
    styleUrls: ['./smslog-popup.component.scss'],
    standalone: false
})
export class SmslogPopupComponent implements OnInit {
  public loaderIcon: Promise<boolean>;
  test:string;
  @ViewChild('SMSLogs', { static: true }) SMSLogs: ModalDirective;
  @ViewChild("tooltip", { static: false }) public tooltip: TooltipComponent;
  modalConfig = {
  backdrop: 'static'
};
  SysDate = new Date();
  SMSLogsResponse: any =[];
  tenantDetails: any;
  filterSettings: Object;
  lines: string;
  customAttri: object;
  faciltyId: number;
  datepipe: DatePipe = new DatePipe('en');  
  constructor(public data: DataService,
    private twoWayService: twoWayService,
    private customerData: CustomerDataService,
    private facOpsDataService: FacOpsDataService,
    private userSessionService: UserSessionService,
    private modalWrapper: ModalWrapperService,

  ) { }

  ngOnInit(): void {
    this.loaderIcon = Promise.resolve(true);
    this.customAttri = { 'class': 'customcss' };
    this.lines = 'Both';
    this.filterSettings = { mode: 'Immediate', immediatemodedelay: 100 };
   this.modalWrapper.openDirective(this.SMSLogs);
    this.faciltyId = this.userSessionService.userSessionData.LastAccessedStoreId?? this.data.custimerInfoStorage.facilityID;
    this.tenantDetails = this.customerData?.CustomerInfoList ? this.customerData.CustomerInfoList : null;
    if (this.tenantDetails == null) {
      const contactInfo = this.facOpsDataService.contactInfo?? '';
      const obj = {
        TenantName: `${contactInfo.FirstName ?? ''} ${contactInfo.MiddleName ?? ''} ${contactInfo.LastName ?? ''}`,
        Phone: contactInfo.BusinessAccount ? (contactInfo.CompanyPhone ? contactInfo.CompanyPhone : '') : (contactInfo.CellPhoneNumber ? contactInfo.CellPhoneNumber : ''),
        EmailID: contactInfo.BusinessAccount ? (contactInfo.CompanyEmail ? contactInfo.CompanyEmail : '') : (contactInfo.Email ? contactInfo.Email : ''),
        Address: contactInfo.BusinessAccount ? (contactInfo.CompanyAddress ? contactInfo.CompanyAddress : '') : (contactInfo.Address ? contactInfo.Address : ''),
        City: contactInfo.BusinessAccount ? (contactInfo.CompanyCity ? contactInfo.CompanyCity : '') : (contactInfo.City ? contactInfo.City : ''),
        TenantId: contactInfo.TenantId ?? '',
        CountryCode: contactInfo.CountryId ?? '',
      };
      this.tenantDetails = obj;
    }
    if(this.tenantDetails.TenantId){
    this.getsmslogs();
    }else{
      this.SMSLogsResponse=[];
      this.loaderIcon =Promise.resolve(false);
    }
  }

  getsmslogs(){
    const obj = {
      FacilityId: this.faciltyId,
      TenantId: this.tenantDetails.TenantId,
      FilterText: 'all',
    };
    this.twoWayService.getSmsLogs(obj).subscribe((res: ISendSMSLogsResponse) => {
      if(res){
        this.SMSLogsResponse = res;
        this.SMSLogsResponse.forEach(element => {
          element.FacilityDateTime = element.FacilityDateTime?.replace('Z', '');
          element.FacilityDateTime = this.datepipe.transform(element.FacilityDateTime, 'MM/dd/yyyy h:mm:ss a');
          if (element.Type === 369) {
            element.Status = 'Received';
          } else if (element.Type === 368) {
            element.Status = 'Sent';
          }
        });
        this.loaderIcon =Promise.resolve(false);
      }
    })
  }

  onCancel(){
    this.SMSLogs.hide();
    this.data.smsLogsPopup = false;
  }
  
  mouseover(args) {
    if (args.target.classList.contains('customcss') && args.target.innerText) {
        this.tooltip.content = args.target.innerText;
    }else if (args.target.classList.contains('customcss') && !args.target.innerText){
        this.tooltip.content = ' ';
    }
  }
  
  dataBound(grid) {
    Object.assign((<any>grid.filterModule).filterOperators, { startsWith: 'contains' });
  }
}
